import api from './api';
import { TOKEN_KEY, USER_ROLE_KEY } from '../utils/constants';

interface EPUserData {
    name: string;
    email: string;
    password: string;
}

interface EPLoginData {
    email: string;
    password: string;
}

export const epRegister = async (userData: EPUserData) => {
  const response = await api.post('/ep/signup', userData);
  return response.data;
};

export const epLogin = async (userData: EPLoginData) => {
    const response = await api.post('/ep/login', userData);
    return response.data;
};

export const getEPProfile = async () => {
    const response = await api.get('/auth/me');
    return response.data;
};

export const epLogout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_ROLE_KEY);
};

// Email OTP verification for EP registration
export const sendEPEmailVerificationOtp = async (email: string) => {
    const response = await api.post('/auth/send-email-verification-otp', { email });
    return response.data;
};

export const verifyEPEmailOtp = async (email: string, otp: string) => {
    const response = await api.post('/auth/verify-email-otp', { email, otp });
    return response.data;
};
